import { atom, useAtomValue, useSetAtom } from 'jotai'
import { MentionableModel } from '../types'
import { useActions } from '../providers'

// Store the models fetched from the backend
const modelsAtom = atom<MentionableModel[]>([])

// Loading state
const isLoadingModelsAtom = atom<boolean>(false)

// Error state
const modelsErrorAtom = atom<string | null>(null)

// Hooks for using the atoms
export const useModels = () => useAtomValue(modelsAtom)
export const useSetModels = () => useSetAtom(modelsAtom)

export const useSetModelsLoading = () => useSetAtom(isLoadingModelsAtom)

export const useSetModelsError = () => useSetAtom(modelsErrorAtom)

// Helper function to fetch models from the backend
export const useFetchModels = () => {
  const setModels = useSetModels()
  const setIsLoading = useSetModelsLoading()
  const setError = useSetModelsError()
  const { getModels } = useActions()

  return async () => {
    setIsLoading(true)
    setError(null)

    try {
      const models = await getModels()
      setModels(models)
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Unknown error occurred')
      console.error('Error fetching models:', error)
    } finally {
      setIsLoading(false)
    }
  }
}
